import React from "react";
import { MdOutlineArrowBackIos } from "react-icons/md";
import "./Return.css";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "../Tooltip";

export function Return({ to }) {
  const navigate = useNavigate();
  return (
    <Tooltip text="Return">
      <button onClick={() => navigate(-1)} className="return-button">
        <MdOutlineArrowBackIos />
      </button>
    </Tooltip>
  );
}

